import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { fetchCustomers, fetchActiveCustomers } from '../../actions/customers_actions';
import { fetchCustomersWithFavorites } from '../../actions/favoriteList_actions';
import { fetchSalesOrderInventory } from '../../actions/inventories_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { fetchFavorites, fetchFavoriteList } from '../../actions/favorites_actions';
import {
  fetchPreviousOrders,
  fetchPreviousSalesOrderByIndexFromLast,
  fetchPreviousSalesOrderByCustomer,
  fetchPreviousOrderById,
  fetchPreviousOrdersFromALLSalesOrder,
  fetchPreviousOrderBySearch,
} from '../../actions/previousOrders_actions';
import { fetchPromotions } from '../../actions/promotions_actions';
import { fetchBaseUsers, fetchPackers, checkPermission } from '../../actions/settings_actions';
import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { setDefaultSearchType } from '../../actions/purchaseOrders_actions';
import { fetchProductInfo, fetchProductInfo2, fetchPackageTypes } from '../../actions/products_actions';
import { clearConvertingToInvoice } from '../../actions/dispatch_actions';
import { clearUpdateSalesInvoice } from '../../actions/salesInvoice_actions';
import { fetchVendors } from '../../actions/vendors_actions';
import SalesOrderForm from '../../components/Sales/salesOrderForm';
import {
  createSalesOrder,
  editSalesOrder,
  keepEstDate,
  destroyEstDate,
  fetchSalesOrderDetail,
  fetchSalesOrderForm,
  clearInventories,
  fetchCustomerPrices,
  fetchTaxRates,
  setSaleRowValue,
  fetchSalesCustomerDetail,
  setCredit,
  setSubtotal,
  resetFormInputs,
  fetchItemSalesHistory,
  fetchItemPurchaseHistory,
  fetchCustomerSalesHistory,
  fetchCustomerFrequent,
  fetchInboundProducts,
  clearSalesCustomerDetails,
  selectSalesOrder,
  initializeForm,
  initializeSalesOrderForm,
  resetCurrentSalesOrder,
  setValue,
  requestSORefund,
  fetchAllShipping,
  setSaleOrderProductValues,
  printShippingList,
  printSalesOrder,
  printPickingList,
  printPackingList,
  printSalesOrderSI,
  finishUnmount,
  fetchSalesOrderDetailByNum,
  updateShippingWeight,
  updateEmployeeNote,
  fetchCarrierInfo,
  postCarrierInfo,
  getPaymentTerms,
  fetchFJAgents,
  fetchFJCarriers,
  fetchFBAAddressOptions,
  fetchCompany,
  fetchWarehousesByCompany,
  createSalesQuote,
  fetchBachesByID,
  fetchProductDetail,
  fetchProductPromotion,
  resetReduxForm,
  convertProduct,
  fetchSalesOrderProductByID,
  fetchTruckCompanies,
  clearSalesOrderFormBatches,
  fetchSalesOrderProductByIDSuccess,
  fetchRollingGate, fetchOrderRequests,
} from '../../actions/sales_actions';
import { fetchRoutesByCustomer } from '../../actions/dispatch_actions';
import { getObjectValue } from '../../components/Common/NumberUtil';

const isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

const validate = (values) => {
  const errors = {};
  if (values.Quantity && !isNumeric(values.Quantity)) {
    errors.Quantity = 'Accept number only!';
  }
  if (values.Quantity && (values.Quantity < 0)) {
    errors.Quantity = 'Positive number only!';
  }
  if (values.UnitPrice && !isNumeric(values.UnitPrice) && values.UnitPrice !== '-') {
    errors.UnitPrice = 'Accept number only!';
  }
  // if (values.UnitPrice && (values.UnitPrice < 0)) {
  //   errors.UnitPrice = 'Positive number only!';
  // }
  if (!values.Deliver_Customer_id) {
    errors.Deliver_Customer_id = 'Required';
  }
  return errors;
};

let salesOrderForm = reduxForm({
  form: 'salesOrderForm',
  validate,
  enableReinitialize: true,
  touchOnChange: true,
  touchOnBlur: false,
})(SalesOrderForm);

salesOrderForm = connect(
  state => ({
    initialValues: state.salesOrders.currentSalesOrderDetail,
  })
)(salesOrderForm);

const selector = formValueSelector('salesOrderForm');

function mapStateToProps(state) {
  const available = selector(state, 'Available');
  const createTime = selector(state, 'CreateTime');
  const creditRadios = selector(state, 'creditRadios');
  const customerChosen = selector(state, 'Deliver_Customer_id');
  const Deliver_CustomerDetail_id = selector(state, 'Deliver_CustomerDetail_id');
  const description = selector(state, 'CustomerDescription');
  const discount = selector(state, 'Discount');

  const dispatchDate = selector(state, 'DispatchDate');
  const dispatchStartTime = selector(state, 'DispatchStartTime');
  const dispatchEndTime = selector(state, 'DispatchEndTime');

  const channel = selector(state, 'Channel');

  const shipByDate = selector(state, 'ShipByDate');
  const ShipDate = selector(state, 'ShipDate');

  const employeeNote = selector(state, 'EmployeeNote');
  const routeNote = selector(state, 'RouteNote');
  const inPurchase = selector(state, 'InPurchase');
  const inventoryIdValue = selector(state, 'Inventory_id');
  const itemNotation = selector(state, 'itemNotation');

  const ReceivedQuantity = selector(state, 'ReceivedQuantity');
  const ShipmentID = selector(state, 'ShipmentID');
  const BillablePallets = selector(state, 'BillablePallets');
  const RealPallets = selector(state, 'RealPallets');
  const BoxPerPallet = selector(state, 'BoxPerPallet');
  const PalletQuantity = selector(state, 'PalletQuantity');
  const Sqft = selector(state, 'Sqft');
  const SqftPack = selector(state, 'SqftPack');
  const LineDiscount =  selector(state, 'LineDiscount');
  const SqftTotal = selector(state, 'SqftTotal');
  const BoxQuantity = selector(state, 'BoxQuantity');
  const PieceQuantity = selector(state, 'PieceQuantity');
  const DispatchType = selector(state, 'DispatchType');
  const BoxVol = selector(state, 'BoxVol');
  const BoxLength = selector(state, 'BoxLength');
  const BoxWidth = selector(state, 'BoxWidth');
  const InnerLabelQty = selector(state, 'InnerLabelQty');
  const OuterLabelQty = selector(state, 'OuterLabelQty');
  const BoxHeight = selector(state, 'BoxHeight');
  const BoxWeight = selector(state, 'BoxWeight');
  const PalletLength = selector(state, 'PalletLength');
  const PalletWidth = selector(state, 'PalletWidth');
  const PalletHeight = selector(state, 'PalletHeight');
  const PalletVol = selector(state, 'PalletVol');
  const PalletWeight = selector(state, 'PalletWeight');
  const IsOversize = selector(state, 'IsOversize');
  const IsOverweight = selector(state, 'IsOverweight');
  const PortDray = selector(state, 'PortDray');
  const DrayageTrucker = selector(state, 'DrayageTrucker');
  const Location = selector(state, 'Location');
  const FBACode = selector(state, 'FBACode');
  const TotalShippingWeight = selector(state, 'TotalShippingWeight');
  const LoadId = selector(state, 'LoadId');
  const Type_wmb2b = selector(state, 'Type_wmb2b');
  const Dept_wmb2b = selector(state, 'Dept_wmb2b');

  const FBARoute = selector(state, 'FBARoute');
  const DimUnit = selector(state, 'DimUnit');
  const IsNoReturn = selector(state, 'IsNoReturn');
  const IsSpare = selector(state, 'IsSpare');
  // const IsCombo = selector(state, 'IsCombo');
  const IsChild = selector(state, 'IsChild');
  const WeightUnit = selector(state, 'WeightUnit');
  const TrailerNum = selector(state, 'TrailerNum');
  const POList = selector(state, 'POList');
  const POD = selector(state, 'POD');

  // const ContainerNum = selector(state, 'ContainerNum');
  const AvailableQuantity = selector(state, 'AvailableQuantity');
  const AvailableQuantityPallet = selector(state, 'AvailableQuantityPallet');
  const AvailableQuantityBox = selector(state, 'AvailableQuantityBox');
  const AvailableQuantityPiece = selector(state, 'AvailableQuantityPiece');

  const notation = selector(state, 'Notation');
  const note = selector(state, 'Note');
  const orderDate = selector(state, 'OrderDate');
  const SalesOrderType = selector(state, 'SalesOrderType');
  const TypeRefNum = selector(state, 'TypeRefNum');
  const preSale = selector(state, 'PreSale');
  const previousOrderFromDate = selector(state, 'PreviousOrderFromDate');
  const previousOrderToDate = selector(state, 'PreviousOrderToDate');
  const quantityValue = selector(state, 'Quantity');
  const receivingCustomer = selector(state, 'receivingCustomer');
  const refPurchasePrice = selector(state, 'RefPurchasePrice');
  const salePrice = selector(state, 'SalePrice');
  const sales = selector(state, 'Sales');
  const soNum = selector(state, 'SONum');
  const searchType = selector(state, 'searchType');
  const searchValue = selector(state, 'ProductInformation');
  const shipperChosen = selector(state, 'CustomerDetail_id');
  const shippingMethod = selector(state, 'ShippingMethod');
  const subtotal = selector(state, 'Subtotal');
  const taxRate = selector(state, 'TaxRate');
  const unitPrice = selector(state, 'UnitPrice');
  const smallUnitPrice = selector(state, 'SmallUnitPrice');
  const weight = selector(state, 'Weight');
  const savings = selector(state, 'Savings');
  const productCost = selector(state, 'ProductCost');
  const baseCost = selector(state, 'BaseCost');
  const Sales_User_id = selector(state, 'Sales_User_id');
  const Sales_User_id2 = selector(state, 'Sales_User_id2');

  const Picker_User_id = selector(state, 'Picker_User_id');
  const Packer_User_id = selector(state, 'Packer_User_id');
  const Creator_User_id = selector(state, 'Creator_User_id');
  const PaymentTerm_id = selector(state, 'PaymentTerm_id');
  const PackageSize_1 = selector(state, 'PackageSize_1');

  const Company_id = selector(state, 'Company_id');
  const Pickup_Warehouse_id = selector(state, 'Pickup_Warehouse_id');
  const svLoading = selector(state, 'svLoading');

  const ShipVia = selector(state, 'ShipVia');

  const shippingChosed = Deliver_CustomerDetail_id || shipperChosen;
  const shippingChosed_id = shippingChosed && getObjectValue(shippingChosed);
  const ETDate = selector(state, 'ETDate');
  const Packer = selector(state, 'Packer');
  const gate_motor = selector(state, 'gate_motor');
  const gate_lock = selector(state, 'gate_lock');
  const reqReviewUserId = selector(state, 'Req_Review_User_id');
  const reqApproveUserId = selector(state, 'Req_Approve_User_id');
  const reviewUserId = selector(state, 'Review_User_id');
  const approveUserId = selector(state, 'Approve_User_id');
  return {
    gate_motor,
    gate_lock,
    Packer,
    shippingChosed_id,
    ShipVia,
    PackageSize_1,
    PaymentTerm_id,
    Sales_User_id,
    Sales_User_id2,
    Picker_User_id,
    Packer_User_id,
    Creator_User_id,
    available,
    createTime,
    creditRadios,
    customerChosen,
    Deliver_CustomerDetail_id,
    description,
    discount,
    Company_id,
    Pickup_Warehouse_id,
    // svLoading,

    dispatchDate,
    dispatchStartTime,
    dispatchEndTime,

    channel,
    shippingMethod,
    shipByDate,
    employeeNote,
    routeNote,
    inPurchase,
    inventoryIdValue,
    itemNotation,

    ReceivedQuantity,
    ShipmentID,
    BillablePallets,
    ShipDate,
    RealPallets,
    BoxPerPallet,
    PalletQuantity,
    Sqft,
    SqftPack,
    LineDiscount,
    SqftTotal,
    BoxQuantity,
    PieceQuantity,
    FBACode,
    DispatchType,
    BoxVol,
    BoxWidth,
    InnerLabelQty,
    OuterLabelQty,
    BoxHeight,
    BoxLength,
    BoxWeight,
    PalletLength,
    PalletWidth,
    PalletHeight,
    PalletVol,
    PalletWeight,
    IsOversize,
    IsNoReturn,
    IsSpare,
    LoadId,
    Type_wmb2b,
    Dept_wmb2b,
    // IsCombo,
    IsChild,
    IsOverweight,
    PortDray,
    DrayageTrucker,
    TotalShippingWeight,
    FBARoute,
    DimUnit,
    WeightUnit,
    TrailerNum,
    POList,
    POD,
    Location,
    // ContainerNum,
    AvailableQuantity,
    AvailableQuantityPallet,
    AvailableQuantityBox,
    AvailableQuantityPiece,
    SalesOrderType,
    TypeRefNum,
    smallUnitPrice,
    notation,
    note,
    orderDate,
    preSale,
    previousOrderFromDate,
    previousOrderToDate,
    quantityValue,
    receivingCustomer,
    refPurchasePrice,
    salePrice,
    sales,
    soNum,
    searchType,
    searchValue,
    shipperChosen,
    subtotal,
    taxRate,
    unitPrice,
    weight,
    savings,
    productCost,
    baseCost,
    ETDate,
    reqReviewUserId,
    reqApproveUserId,
    reviewUserId,
    approveUserId,
    users: state.settings.all,
    productPromotions: state.salesOrders.promotions,
    currentSalesOrder: state.salesOrders.currentSalesOrder,
    currentSalesOrderDetail: state.salesOrders.currentSalesOrderDetail,
    from: state.salesOrders.from,
    detailIsLoading: state.salesOrders.detailIsLoading,
    detailError: state.salesOrders.detailError,
    initialValues: state.salesOrders.currentSalesOrderDetail,
    packers: state.settings.packers,

    customers: state.customers.all,
    customersIsLoading: state.customers.isLoading,
    customersError: state.customers.error,

    isCreating: state.salesOrders.isCreating,
    createError: state.salesOrders.createError,
    created: state.salesOrders.created,
    isEditing: state.salesOrders.isEditing,
    editError: state.salesOrders.editError,
    edited: state.salesOrders.edited,

    salesOrderEdited: state.salesOrders.salesOrderEdited,
    salesOrderIsEditing: state.salesOrders.salesOrderIsEditing,
    salesOrderEditError: state.salesOrders.salesOrderEditError,

    salesOrderCreated: state.salesOrders.salesOrderCreated,
    salesOrderIsCreating: state.salesOrders.salesOrderIsCreating,
    salesOrderCreateError: state.salesOrders.salesOrderCreateError,

    customerPrices: state.salesOrders.customerPrices,
    customerPricesIsLoading: state.salesOrders.customerPricesIsLoading,
    customerPricesError: state.salesOrders.customerPricesError,

    inventories: state.inventories.salesOrderInventory,
    inventoriesIsLoading: state.inventories.salesOrderInventoryIsLoading,
    inventoriesError: state.inventories.salesOrderInventoryError,

    // favorites: state.favorites.all,
    // favoritesIsLoading: state.favorites.isLoading,
    // favoritesError: state.favorites.error,
    // currentFavorites: state.favorites.currentFavorites,

    customersWithFavorites: state.customerFavorites.customersWithFavorites,

    previousSOs: state.previousOrders.SOs,
    previousOrders: state.previousOrders.all,
    previousOrdersIsLoading: state.previousOrders.isLoading,
    previousOrdersError: state.previousOrders.error,
    currentPreviousOrders: state.previousOrders.currentPreviousOrders,

    salesOrderDetailByNum: state.salesOrders.currentSalesOrderDetailByNum,
    detailByNumIsLoading: state.salesOrders.detailByNumIsLoading,
    detailByNumError: state.salesOrders.detailByNumError,

    promotions: state.promotions.all,
    promotionsIsLoading: state.promotions.isLoading,
    promotionsError: state.promotions.error,
    currentPromotions: state.promotions.currentPromotions,
    userPermissions: state.auth.userPermissions,

    taxRates: state.salesOrders.taxRates,
    taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
    taxRatesError: state.salesOrders.taxRatesError,

    paymentTerms: state.paymentTerms.all,
    paymentTermsIsLoading: state.paymentTerms.isLoading,
    paymentTermsError: state.paymentTerms.error,

    salesCustomerDetails: state.salesOrders.salesCustomerDetails,
    salesShippingCustomerDetails: state.salesOrders.salesShippingCustomerDetails,
    salesCustomerDetailsIsLoading: state.salesOrders.salesCustomerDetailsIsLoading,
    salesCustomerDetailsError: state.salesOrders.salesCustomerDetailsError,

    allShipping: state.salesOrders.allShipping,
    allShippingIsLoading: state.salesOrders.allShippingIsLoading,
    allShippingError: state.salesOrders.allShippingError,

    salesItemHistory: state.salesOrders.salesItemHistory,
    salesItemHistoryIsLoading: state.salesOrders.salesItemHistoryIsLoading,
    salesItemHistoryError: state.salesOrders.salesItemHistoryError,

    customerSalesHistory: state.salesOrders.customerSalesHistory,
    customerSalesHistoryIsLoading: state.salesOrders.customerSalesHistoryIsLoading,
    customerSalesHistoryError: state.salesOrders.customerSalesHistoryError,

    customerFrequent: state.salesOrders.customerFrequent,
    customerFrequentIsLoading: state.salesOrders.customerFrequentIsLoading,
    customerFrequentError: state.salesOrders.customerFrequentError,

    productInfo: state.products.productInfo,
    productInfoIsLoading: state.products.productInfoIsLoading,
    productInfoError: state.products.productInfoError,

    favoriteList: state.favorites.favoriteList,
    favoriteListIsLoading: state.favorites.favoriteListIsLoading,
    favoriteListError: state.favorites.favoriteListError,

    checkingPermission: state.settings.checkingPermission,
    checkPermissionSuccess: state.settings.checkPermissionSuccess,
    checkPermissionFailure: state.settings.checkPermissionFailure,

    salesOrderProduct: state.salesOrders.salesOrderProduct,
    salesOrderProductIsLoading: state.salesOrders.salesOrderProductIsLoading,
    svLoading: state.salesOrders.svLoading,
    salesOrderProductFailure: state.salesOrders.salesOrderProductFailure,

    requestingShippingList: state.salesOrders.requestingShippingList,
    shippingListPDF: state.salesOrders.shippingListPDF,

    requestingPickingList: state.salesOrders.requestingPickingList,
    pickingListPDF: state.salesOrders.pickingListPDF,

    requestingPackingList: state.salesOrders.requestingPackingList,
    packingListPDF: state.salesOrders.packingListPDF,

    requestingSalesOrderPDF: state.salesOrders.requestingSalesOrderPDF,
    salesOrderPDF: state.salesOrders.salesOrderPDF,

    requestingSalesOrderSIPDF: state.salesOrders.requestingSalesOrderSIPDF,
    salesOrderSIPDF: state.salesOrders.salesOrderSIPDF,

    requestingRefundPDF: state.salesOrders.requestingRefundPDF,
    refundPDF: state.salesOrders.refundPDF,

    prevEstDate: state.salesOrders.prevEstDate,
    prevEstDateIsNeeded: state.salesOrders.prevEstDateIsNeeded,

    batchesInfo: state.salesOrders.batchesInfo,
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
    truckCompanies: state.salesOrders.truckCompanies,

    packageTypesFetched: state.products.packageTypesFetched, // pkg type
    activeIdx: state.salesOrders.activeIdx,
    currentProductRequests: state.salesOrders.currentProductRequests,
    currentProductImages: JSON.stringify(state.salesOrders.currentProductImages),
    currentProductFiles: JSON.stringify(state.salesOrders.currentProductFiles),
  };
}

export default connect(mapStateToProps, {
  fetchTruckCompanies,
  checkPermission,
  clearConvertingToInvoice,
  clearInventories,
  clearSalesCustomerDetails,
  clearUpdateSalesInvoice,
  createSalesOrder,
  destroyEstDate,
  editSalesOrder,
  fetchActiveCustomers,
  fetchBachesByID,
  fetchAllShipping,
  fetchBaseUsers,
  fetchPackers,
  fetchCustomerSalesHistory,
  fetchCustomerFrequent,
  fetchInboundProducts,
  fetchCustomerPrices,
  fetchCustomers,
  fetchCustomersWithFavorites,
  fetchFavoriteList,
  fetchFavorites,
  fetchItemSalesHistory,
  fetchItemPurchaseHistory,
  fetchPaymentTerms,
  fetchPreviousOrders,
  fetchPreviousOrderById,
  fetchPreviousSalesOrderByIndexFromLast,
  fetchPreviousSalesOrderByCustomer,
  fetchPreviousOrdersFromALLSalesOrder,
  fetchPreviousOrderBySearch,
  fetchProductInfo,
  fetchProductInfo2,
  fetchPromotions,
  fetchSalesCustomerDetail,
  fetchRoutesByCustomer,
  fetchSalesOrderDetail,
  fetchSalesOrderForm,
  fetchSalesOrderInventory,
  fetchTaxRates,
  finishUnmount,
  initializeForm,
  initializeSalesOrderForm,
  keepEstDate,
  printPackingList,
  printPickingList,
  printSalesOrder,
  printShippingList,
  requestSORefund,
  resetCurrentSalesOrder,
  resetFormInputs,
  selectSalesOrder,
  setCredit,
  setDefaultSearchType,
  setSaleOrderProductValues,
  setSaleRowValue,
  setSubtotal,
  setValue,
  fetchSalesOrderDetailByNum,
  fetchVendors,
  updateShippingWeight,
  updateEmployeeNote,
  fetchCarrierInfo,
  postCarrierInfo,
  getPaymentTerms,
  fetchFJAgents,
  fetchFJCarriers,
  fetchFBAAddressOptions,
  setDefaultOfForm,
  printSalesOrderSI,
  fetchCompany,
  fetchWarehousesByCompany,
  createSalesQuote,
  fetchProductDetail,
  fetchProductPromotion,
  convertProduct,
  fetchSalesOrderProductByID,
  fetchSalesOrderProductByIDSuccess,
  resetReduxForm: () => dispatch => dispatch(resetReduxForm('salesOrderForm')),
  clearSalesOrderFormBatches,
  fetchRollingGate,
  fetchPackageTypes,
  fetchOrderRequests,
})(salesOrderForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/salesOrderForm.jsx